import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { useEffect } from "react";
import type { AppDispatch } from "../../store";

export const createUseItems =
  (fetcher: any, statePath: (storeState: any) => any) => (params?: any) => {
    const dispatch = useDispatch<AppDispatch>();
    const { status, error, items } = useSelector((state: any) => {
      const slice = statePath(state);
      return {
        status: fetcher.selectors.getStatus(slice),
        error: fetcher.selectors.getError(slice),
        items: fetcher.selectors.getItems(slice),
      };
    }, shallowEqual);

    // fetch item on mount
    useEffect(() => {
      dispatch(fetcher.actions.fetchItems(params));
    }, [params, dispatch]);

    return { status, error, items };
  };
